import {
  Box, Chip, IconButton,
  Input, Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import {IconArrowsMaximize} from "@tabler/icons-react";
import GraphComponent from "../../components/GraphComponent";
import {GraphModal} from "./GraphModal";

const ViewType = {
  TABLE: "TABLE",
  GRAPH: "GRAPH"
}

export const MetadataTable = ({ metadata }) => {
  const [fullScreen, setFullScreen] = useState(false);
  const [view, setView] = useState(ViewType.TABLE);
  const [filter, setFilter] = useState({ subject: "", predicate: "", object: "" });
  const [parentWidth, setParentWidth] = useState(0); // State to track the parent width
  const [parentHeight, setParentHeight] = useState(0); // State to track the parent width
  const parentRef = useRef(null); // Reference for the parent Box

  // Set parent width on mount and resize
  useEffect(() => {
    const handleResize = () => {
      if (parentRef.current) {
        setParentWidth(parentRef.current.offsetWidth);
        setParentHeight(parentRef.current.offsetHeight);
      }
    };

    handleResize(); // Set initial width
    window.addEventListener("resize", handleResize); // Update on resize

    return () => window.removeEventListener("resize", handleResize); // Cleanup on unmount
  }, []);

  const filteredMetadata = metadata?.filter(item =>
    (!filter.subject || item.subject?.toLowerCase().includes(filter.subject.toLowerCase())) &&
    (!filter.predicate || item.predicate?.toLowerCase().includes(filter.predicate.toLowerCase())) &&
    (!filter.object || item.object?.toLowerCase().includes(filter.object.toLowerCase()))
  );

  return (
    <Box ref={parentRef} sx={{ flex: 5, minHeight: "70dvh", maxHeight: "70dvh", overflowY: "auto", overflowX: "hidden", position: "relative" }}>
      {fullScreen && <GraphModal
        open={fullScreen} handleClose={() => setFullScreen(false)} metadata={metadata}
      />}
      {!fullScreen && <Stack direction={"row"} gap={2} sx={{position: "absolute", top: 0, right: 0, left: 0, zIndex: 10000}}>
        <Chip label={"Graph"} color={view === ViewType.GRAPH ? "info" : "default"} onClick={() => setView(ViewType.GRAPH)} sx={{ borderRadius: 1 }} />
        <Chip label={"Table"} color={view === ViewType.TABLE ? "info" : "default"} onClick={() => setView(ViewType.TABLE)} sx={{ borderRadius: 1 }} />
        <IconButton sx={{ml: "auto"}} onClick={() => setFullScreen(true)}>
          <IconArrowsMaximize size={18} />
        </IconButton>
      </Stack>}
      {
        {
          [ViewType.GRAPH]: (
            <>

              <GraphComponent metadata={metadata} width={parentWidth} height={parentHeight} />
            </>
          ),
          [ViewType.TABLE]: (
            <Table stickyHeader sx={{mt: "40px"}}>
              <TableHead>
                <TableRow className={"selected"}>
                  <TableCell sx={{px: 2, py: 1}}>
                    <Input
                      placeholder={"Subject"} disableUnderline
                      value={filter.subject}
                      onChange={e => setFilter({ ...filter, subject: e.target.value })}
                      slotProps={{
                        input: {
                          sx: { "&::placeholder": { opacity: 1, fontWeight: 700 } }
                        }
                      }}
                    />
                  </TableCell>
                  <TableCell sx={{px: 2, py: 1}}>
                    <Input
                      placeholder={"Predicate"} disableUnderline
                      value={filter.predicate}
                      onChange={e => setFilter({ ...filter, predicate: e.target.value })}
                      slotProps={{
                        input: {
                          sx: { "&::placeholder": { opacity: 1, fontWeight: 700 } }
                        }
                      }}
                    />
                  </TableCell>
                  <TableCell sx={{px: 2, py: 1}}>
                    <Input
                      placeholder={"Object"} disableUnderline
                      value={filter.object}
                      onChange={e => setFilter({ ...filter, object: e.target.value })}
                      slotProps={{
                        input: {
                          sx: { "&::placeholder": { opacity: 1, fontWeight: 700 } }
                        }
                      }}
                    />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredMetadata?.map(item => (
                  <TableRow key={JSON.stringify(item)} className={"selected"}>
                    <TableCell sx={{px: 2, py: 1}}>{item?.subject}</TableCell>
                    <TableCell sx={{px: 2, py: 1}}>{item?.predicate}</TableCell>
                    <TableCell sx={{px: 2, py: 1}}>{item?.object}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )
        }[view]
      }
    </Box>
  );
};
